import { html, rune, type Html, View } from 'rune-ts';
import klass from './StatisticsSection.module.scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { staticTypoPcMo, typoPcMo } from '../../../../../shared/typography/typo';
import { ButtonCtaLanding } from '../../../../../shared/components/atoms/ButtonCtaLanding/ButtonCtaLanding';
import { ArrowRightIcon } from '../../../../components/atoms/Icon';
import { plusIcon } from '../../icons';

export class StatisticsSection extends View {
  ctaButton = new ButtonCtaLanding({
    type: 'black',
    label: ET(`mps2::landing::handmade::statistics_button`),
    klass: `${klass.link} link`,
  });

  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      statistics_title: html.preventEscape(ET(`mps2::landing::handmade::statistics_title`)),
      statistics_description: html.preventEscape(
        ET(`mps2::landing::handmade::${is_mobile ? 'mo_' : ''}statistics_description`),
      ),
      statistics_title_1: ET(`mps2::landing::handmade::statistics_title_1`),
      statistics_title_2: ET(`mps2::landing::handmade::statistics_title_2`),
      statistics_title_3: ET(`mps2::landing::handmade::statistics_title_3`),
      statistics_title_4: ET(`mps2::landing::handmade::statistics_title_4`),
      statistics_title_5: ET(`mps2::landing::handmade::statistics_title_5`),
    };

    return html`
      <section class="${klass.statistics}">
        <div class="${klass.left_wrapper}">
          <video
            preload="none"
            autoplay=""
            loop=""
            muted=""
            playsinline=""
            src="//s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/easter-egg.mp4"
          ></video>

          <div class="${klass.content}">
            <div class="${klass.info}">
              <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '16_medium' })}">
                ${texts.statistics_title_1}
              </div>
              <div
                class="${klass.count}"
              >
                <span class="${staticTypoPcMo({
                  is_mobile,
                  pc: 'bebas_60_bold',
                  mo: 'bebas_48_bold',
                })}">83,000</span>
                <span class="${typoPcMo({
                  is_mobile,
                  pc: '48_bold',
                  mo: '40_bold',
                })}">명</span>
                ${plusIcon}
              </div>
            </div>
            <div class="${klass.info}">
              <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '16_medium' })}">
                ${texts.statistics_title_2}
              </div>
              <div
                class="${klass.count}"
              >
                <span class="${staticTypoPcMo({
                  is_mobile,
                  pc: 'bebas_60_bold',
                  mo: 'bebas_48_bold',
                })}">17,200,000</span>
                <span class="${typoPcMo({
                  is_mobile,
                  pc: '48_bold',
                  mo: '40_bold',
                })}">원</span>
                ${plusIcon}
              </div>
            </div>
          </div>

          <div class="${klass.source}">${ET(`mps2::landing::handmade::statistics_date`)}</div>
        </div>

        <div class="${klass.right_wrapper}">
          <div class="${klass.content}">
            <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '40_bold', mo: '24_bold' })} ">
              ${texts.statistics_title}
            </div>
            <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_medium' })} ">
              ${texts.statistics_description}
            </div>
            <a href="https://marpple.shop/" target="_blank">
              <div class="${klass.link} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })}">
                ${ET(`mps2::landing::handmade::statistics_button`)}
                <div class="${klass.arrow_button}">${ArrowRightIcon}</div>
              </div>
            </a>
          </div>
          <div class="${klass.banners}">
            <div class="${klass.banner_row}">
              <div class="${klass.banner} ${klass.banner_sm}"">
                <img
                  class="${klass.image}"
                  src="${getResizedUrl({
                    url: '//s3.marpple.co/files/u_4648126/2024/10/original/846a652369e79c1ac083f298358970e250faa5f91.png',
                    width: 1920 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="MarppleShop handmade craft Image"
                />
                <div class="${klass.info}">
                  <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '16_medium' })}">
                    ${texts.statistics_title_3}
                  </div>
                  <div
                    class="${klass.count}"
                  >
                    <span class="${staticTypoPcMo({
                      is_mobile,
                      pc: 'bebas_60_bold',
                      mo: 'bebas_32_bold',
                    })}">650</span>
                    <span class="${typoPcMo({
                      is_mobile,
                      pc: '48_bold',
                      mo: '28_bold',
                    })}">억</span>
                    ${plusIcon}
                  </div>
                </div>
              </div>
              <div class="${klass.banner} ${klass.banner_sm}"">
                <img
                  class="${klass.image}"
                  src="${getResizedUrl({
                    url: '//s3.marpple.co/files/u_4648126/2024/10/original/0fbf7e179a222799f4c4ed8c4192811c9ead508e1.png',
                    width: 1920 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="MarppleShop handmade craft Image"
                />
                <div class="${klass.info}">
                  <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '16_medium' })}">
                    ${texts.statistics_title_4}
                  </div>
                  <div
                    class="${klass.count}"
                  >
                    <span class="${staticTypoPcMo({
                      is_mobile,
                      pc: 'bebas_60_bold',
                      mo: 'bebas_32_bold',
                    })}">210</span>
                    <span class="${typoPcMo({
                      is_mobile,
                      pc: '48_bold',
                      mo: '28_bold',
                    })}">만 명</span>
                    ${plusIcon}
                  </div>
                </div>
              </div>
            </div>
            <div class="${klass.banner_row}">
              <div class="${klass.banner} ${klass.banner_lg}">
                <img
                  class="${klass.image}"
                  src="${getResizedUrl({
                    url: '//s3.marpple.co/files/u_4648126/2024/10/original/69918ccc38fd3751bcb9ed758d137c66287abab11.png',
                    width: 1920 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="MarppleShop handmade craft Image"
                />
                <div class="${klass.info}">
                  <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '16_medium' })}">
                    ${texts.statistics_title_5}
                  </div>
                  <div
                    class="${klass.count} ${staticTypoPcMo({
                      is_mobile,
                      pc: 'bebas_60_bold',
                      mo: 'bebas_48_bold',
                    })}""
                  >
                    27%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
  }
}
